<ng-container *ngTemplateOutlet="empty" />

<ng-template #empty>
    <app-empty-content-list-element contentType="playlist" />
</ng-template>